<script setup lang="ts">
// Report table header label: the column's metric view plus, when the column's values came from GA4
// data (ORP-25550 / ORP-25673), v3 `OrphexTh`'s orange dot. The header sits inside the sort button
// and the column-description tooltip, so the dot stays passive: the GA4 explanation arrives as the
// column's description (`markGa4Columns`) and screen readers get the same words as v3's aria-label.
import type { ReportColumn } from '../../models/column.types'

import { useI18n } from '@/shared/i18n'
import { MetricView } from '@/shared/ui/metric-view'

withDefaults(defineProps<{ column: ReportColumn; channel?: string }>(), { channel: '' })

const { t } = useI18n()
</script>

<template>
  <MetricView v-if="!column.ga4Override" :column="column" :channel="channel" />
  <span v-else class="report-header-label inline-flex min-w-0 items-start">
    <MetricView :column="column" :channel="channel" aria-hidden="true" />
    <span class="sr-only">{{ t('reports.ga4.ariaLabel', { label: column.header }) }}</span>
    <span
      aria-hidden="true"
      class="report-header-label__ga4-dot ml-0.5 mt-0.5 size-1.5 shrink-0 rounded-full bg-accent"
    />
  </span>
</template>
